import React from "react";
// import NavigationMenu from "../components/NavigationMenu";
import LogoBlanc from "../components/LogoBlanc";
// import Titre from "../components/Titre";
import SplitSlideshow from "../components/MouseZoneBackground";

const Home = () => {
  return (
<>
  {/* <NavigationMenu /> */}
  <LogoBlanc />
  {/* <Titre /> */}
      <div className="horizontal-scroll">
      <div className="section">
        <div className="menu-grid">
        <div className="menu-grid-bloc">
  <SplitSlideshow />
</div>
          {/* <div className="menu-grid-bloc"></div>
          <div className="menu-grid-bloc"></div>
          <div className="menu-grid-bloc"></div> */}
        </div>
      </div>
    </div>
    </>
  );
};

export default Home;